import React from "react";

interface Props {
    title: string;
    titleHighlight?: string;
    subtitle?: string;
}

const ListPageHeader: React.FC<Props> = ({ title, titleHighlight, subtitle }) => (
    <div className="space-y-2">
        <h1 className="text-3xl font-black tracking-tight sm:text-4xl">
            {title}
            {titleHighlight && <> <span className="text-primary">{titleHighlight}</span></>}
        </h1>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
    </div>
);

export default ListPageHeader;
